import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const GoogleMapContext = React.createContext({});

export const withGoogleMap = Component => props => {
  return <GoogleMapContext.Consumer>{(map) => <Component map={map} {...props}/>}</GoogleMapContext.Consumer>;
};

const DefaultMapContainer = styled.div`
  width: 100%;
  height: 320px;
  @media(max-width: 700px) {
    height: 264px;
  }
`;

const createGoogleMap = BaseComponentWithScript => {
  class Container extends React.PureComponent {
    static propTypes = {
      mapContainer: PropTypes.element
    }

    static defaultProps = {
      mapContainer: <DefaultMapContainer />,
      defaultCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      defaultZoom: 5
    };

    state = {
      map: null,
    }

    handleComponentMount = (node) => {
      if (this.state.map || node === null) {
        return;
      }
      const { defaultCenter, defaultZoom } = this.props;
      const map = new google.maps.Map(node, {
        center: {
          lat: defaultCenter.lat, lng: defaultCenter.lng
        },
        zoom: defaultZoom
      });
      this.setState({ map });
    }

    render() {
      const { mapContainer, ...restProps } = this.props;

      if (!this.state.map) {
        return React.cloneElement(
          mapContainer,
          {},
          React.cloneElement(
            <GoogleMapContext.Provider value={this.state.map} />,
            {},
            <div ref={this.handleComponentMount} style={{ height: '100%' }}></div>
          )
        );
      }
      return React.cloneElement(
        mapContainer,
        {},
        React.cloneElement(
          <GoogleMapContext.Provider value={this.state.map} />,
          {},
          <div ref={this.handleComponentMount} style={{ height: '100%' }}><BaseComponentWithScript {...restProps}/></div>
        )
      );
    }
  }

  return Container;
};

export default createGoogleMap;
